'use client';

import { c as _c } from "react/compiler-runtime";
import { Breadcrumb, Breadcrumbs as RAC_Breadcrumbs } from 'react-aria-components';
import { Link } from '~/components/Link';
import styles from './Breadcrumbs.module.css';
import type { BreadcrumbsProps } from './Breadcrumbs.types';
export function Breadcrumbs(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles.breadcrumbsContainer}><RAC_Breadcrumbs className={styles.breadcrumbs}>{t1}</RAC_Breadcrumbs></div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(item) {
  return <Breadcrumb key={item.href} className={styles.breadcrumb}><Link className={styles.link} href={item.href} aria-current={item.isCurrent ? "true" : undefined} target="_self">{item.isCurrent ? <strong>{item.label}</strong> : item.label}</Link></Breadcrumb>;
}